module.exports = __webpack_public_path__ + "static/media/details-29-image-1.494d11db.jpg";